import api from "src/api/axios";

export const getAllTypeService = async (data = null) => {
  const params = new URLSearchParams();

  if (data) {
    Object.keys(data).map((key) => {
      if (data[key]) {
        params.append(key, data[key]);
      }
    });
  }

  return api.get(`/type?${params}`).then((result) => {
    return result.data;
  });
};

export const createType = (data) =>
  api.post("/type", data).then((result) => result.data);

export const updateType = (id, data) =>
  api.patch(`/type/${id}`, data).then((result) => result.data);

export const getSingleType = (id) =>
  api.get(`/type/${id}`).then((result) => result.data);

export const deleteType = (id) =>
  api.delete(`/type/${id}`).then((result) => result.data);
